<template>
  <v-sheet class="profile-card"  >
    <v-list-item two-line >
      <v-list-item-content>
        <v-list-item-title class="mb-2">{{ header }}</v-list-item-title>
        <v-list-item-subtitle>{{ content }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-icon class="ml-auto my-auto">
        <v-icon :color="color ? color : 'primary'" size="32">{{ 'mdi-'.concat(icon) }}</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </v-sheet>
</template>

<script>
export default {
  name: "BasicInfoDisplay",
  props: ['header', 'content', 'icon', 'color'], 
  // props: {
  //   header: String, 
  //   content: Number, 
  //   icon: String, 
  //   color: String,
  // }, 

  computed: {
    isMobile: function() {
      return this.$vuetify.breakpoint.smAndDown
    }, 

    isMediumAndUp: function() {
      return this.$vuetify.breakpoint.mdAndUp
    }
  }

}
</script>




<style lang="css" scoped>

.profile-card, .details-card, .status-card {
    background: white;
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
    }
  }

</style>